"use client";

import { useRouter } from "next/navigation";

interface Props {
  open: boolean;
  onClose: () => void;
}

export default function ProfileNudgeModal({ open, onClose }: Props) {
  const router = useRouter();

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="profile-nudge-title"
    >
      <div className="bg-white rounded-lg max-w-md w-full p-6 md:p-8 shadow-xl">
        <h2
          id="profile-nudge-title"
          className="text-base font-bold text-on-surface mb-3 text-left"
        >
          プロフィール設定はお済みですか？
        </h2>
        <p className="text-sm text-on-surface mb-6 leading-relaxed">
          職歴や志望職種を登録するだけで、今のあなたに必要な質問が自動で絞り込まれます。
        </p>

        <div className="flex flex-col gap-3 md:flex-row md:justify-end md:gap-3">
          <button
            type="button"
            onClick={onClose}
            className="w-full md:w-auto bg-surface border border-outline-variant text-on-surface font-semibold px-5 py-3 rounded-lg transition-colors hover:bg-surface-container-low min-h-[44px]"
          >
            あとで設定する
          </button>
          <button
            type="button"
            onClick={() => router.push("/profile")}
            className="w-full md:w-auto bg-primary hover:bg-primary-hover text-white font-bold px-5 py-3 rounded-lg transition-colors min-h-[44px]"
          >
            プロフィールを編集
          </button>
        </div>
      </div>
    </div>
  );
}
